import {createSlice} from '@reduxjs/toolkit'
import loadInitialStateObject from './initialStateUtil'

const suretyBondSlice = createSlice({
    name : 'suretyBond',
    initialState : loadInitialStateObject('suretyBond'),
    reducers : {

    }
})

export default suretyBondSlice.reducer
